import { Address } from '@app-models';

export class Physician {
    id?: number;
    firstName: string;
    lastName: string;
    emailAddress?: string;
    phoneNumber?: string;
    addresses?: Address[];
}
